import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "voucher-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "pax-name" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "travel-destination" }
const _hoisted_8 = { class: "vertical-unset" }
const _hoisted_9 = { class: "mr-3 travel-destination-title" }
const _hoisted_10 = { style: {"display":"block"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "vertical-unset" }
const _hoisted_16 = { class: "mr-3 travel-destination-title" }
const _hoisted_17 = { style: {"display":"block"} }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "voucher-use-time" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = {
  style: {"font-size":"15px"},
  class: "d-flex align-center justify-content-center"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "border-wrap" }
const _hoisted_51 = { class: "title" }
const _hoisted_52 = {
  key: 0,
  class: "title"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "border-wrap mta4-3" }
const _hoisted_56 = { class: "title" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "mta4-3" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "mta4-3" }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = { class: "mta4-3" }
const _hoisted_63 = { key: 3 }
const _hoisted_64 = { class: "mta4-3" }
const _hoisted_65 = { key: 4 }
const _hoisted_66 = ["innerHTML"]
const _hoisted_67 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxiData, (data, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.details, (dataDetail, indexDetail) => {
        return (_openBlock(), _createElementBlock("div", {
          key: indexDetail,
          class: "pagebreak"
        }, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { span: 24 }, {
                    default: _withCtx(() => [
                      (_ctx.getLinkImgVoucher(_ctx.taxiLanguage[index], 'linkLogo', _ctx.showSecondLanguage))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", {
                              class: "voucher-logo",
                              style: _normalizeStyle(
                  'float:' +
                  ((_ctx.taxiLanguage[index].paxLang.posLogo ?? _ctx.taxiLanguage[index].enLang.posLogo) == 'left' ? 'left' : 'right')
                )
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getLinkImgVoucher(_ctx.taxiLanguage[index], 'linkLogo', _ctx.showSecondLanguage),
                                width: "150"
                              }, null, 8, _hoisted_2)
                            ], 4)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("strong", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c1), 1),
                              (_ctx.showSecondLanguage)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_4,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c1), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c2), 1),
                    (_ctx.showSecondLanguage)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_6,
                          _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c2), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("table", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c33), 1)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_10, [
                                  (dataDetail?.destination?.name)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("span", null, _toDisplayString(dataDetail.destination.name), 1),
                                        _hoisted_12
                                      ]))
                                    : _createCommentVNode("", true),
                                  (dataDetail?.destination?.address)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(dataDetail.destination.address), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.showSecondLanguage)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                                    _createElementVNode("td", _hoisted_15, [
                                      _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c33), 1)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_17, [
                                      (dataDetail?.destination?.name)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createElementVNode("span", null, _toDisplayString(dataDetail.destination.name), 1),
                                            _hoisted_19
                                          ]))
                                        : _createCommentVNode("", true),
                                      (dataDetail?.destination?.address)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(dataDetail.destination.address), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, {
                    class: "mta4-3 taxi",
                    gutter: 25
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c3), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_22,
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c3), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_23,
                          _createElementVNode("p", {
                            class: "mt-1",
                            innerHTML: _ctx.languageReplace(_ctx.taxiLanguage[index].enLang.p2c4, { '<amount>': dataDetail.est_amount })
                          }, null, 8, _hoisted_24),
                          _createElementVNode("p", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c6), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c5), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_25,
                                _createElementVNode("p", {
                                  class: "mt-1",
                                  innerHTML: _ctx.languageReplace(_ctx.taxiLanguage[index].paxLang.p2c4, { '<amount>': dataDetail.est_amount })
                                }, null, 8, _hoisted_26),
                                _createElementVNode("p", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c6), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c5), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(data.currency) + " " + _toDisplayString(dataDetail.est_amount), 1),
                          _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c16), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c16), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("img", {
                            class: "qrcode",
                            src: 'data:image/png;base64,' + data.qrCodeDetail.qr_code
                          }, null, 8, _hoisted_29),
                          _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c22) + _toDisplayString(data.qrCodeDetail.link_mobile), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_30,
                                _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c22) + _toDisplayString(data.qrCodeDetail.link_mobile), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, {
                    class: "mta4-3",
                    gutter: 25
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c7), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_31,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c7), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.taxiLanguage[index].paxLang.icon_spend
                          ? _ctx.taxiLanguage[index].paxLang.icon_spend
                          : _ctx.taxiLanguage[index].enLang.icon_spend
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.taxiLanguage[index].paxLang?.p2c9 ?? _ctx.taxiLanguage[index].enLang.p2c9), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    innerHTML: _ctx.languageReplace(_ctx.taxiLanguage[index].enLang.p2c15, { '<amount>': dataDetail.est_amount })
                                  }, null, 8, _hoisted_33),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_34,
                                        _createElementVNode("span", {
                                          innerHTML: _ctx.languageReplace(_ctx.taxiLanguage[index].paxLang.p2c15, { '<amount>': dataDetail.est_amount })
                                        }, null, 8, _hoisted_35)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.taxiLanguage[index].paxLang.icon_scan
                          ? _ctx.taxiLanguage[index].paxLang.icon_scan
                          : _ctx.taxiLanguage[index].enLang.icon_scan
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.taxiLanguage[index].paxLang?.p2c10 ?? _ctx.taxiLanguage[index].enLang.p2c10), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c16), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_37,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c16), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.taxiLanguage[index].paxLang.icon_receipt
                          ? _ctx.taxiLanguage[index].paxLang.icon_receipt
                          : _ctx.taxiLanguage[index].enLang.icon_receipt
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.taxiLanguage[index].paxLang?.p2c11 ?? _ctx.taxiLanguage[index].enLang.p2c11), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c17), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_39,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c17), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.taxiLanguage[index].paxLang.icon_bank
                          ? _ctx.taxiLanguage[index].paxLang.icon_bank
                          : _ctx.taxiLanguage[index].enLang.icon_bank
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.taxiLanguage[index].paxLang?.p2c12 ?? _ctx.taxiLanguage[index].enLang.p2c12), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c18), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_41,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c18), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.taxiLanguage[index].paxLang.icon_wire
                          ? _ctx.taxiLanguage[index].paxLang.icon_wire
                          : _ctx.taxiLanguage[index].enLang.icon_wire
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.taxiLanguage[index].paxLang?.p2c13 ?? _ctx.taxiLanguage[index].enLang.p2c13), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c19), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_43,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c19), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { class: "mta4-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(["icon-border", 
                        _ctx.taxiLanguage[index].paxLang.icon_receive
                          ? _ctx.taxiLanguage[index].paxLang.icon_receive
                          : _ctx.taxiLanguage[index].enLang.icon_receive
                      ]),
                                      style: _normalizeStyle(_ctx.iconStyle)
                                    }, null, 6),
                                    _createElementVNode("span", {
                                      class: "color-text-icon",
                                      style: _normalizeStyle(_ctx.colorStyle)
                                    }, _toDisplayString(_ctx.taxiLanguage[index].paxLang?.p2c14 ?? _ctx.taxiLanguage[index].enLang.p2c14), 5)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c20), 1),
                                  (_ctx.showSecondLanguage)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_45,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c20), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c23), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_46,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c23), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_47,
                          _hoisted_48,
                          _createElementVNode("p", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c24), 1),
                          (_ctx.showSecondLanguage)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c24), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c25) + ":", 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c25) + ":", 1))
                              : _createCommentVNode("", true),
                            _hoisted_53,
                            _createElementVNode("p", null, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c26), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c26), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c27), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c27), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c28), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c28), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c29), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c29), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c30), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c30), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.taxiLanguage[index].enLang.p2c31), 1),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(_ctx.taxiLanguage[index].paxLang.p2c31), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", {
                              class: "mta4-3",
                              innerHTML: _ctx.languageReplace(_ctx.taxiLanguage[index].enLang.p2c32, { '<voucher_code>': dataDetail?.voucher_code })
                            }, null, 8, _hoisted_66),
                            (_ctx.showSecondLanguage)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 5,
                                  innerHTML: _ctx.languageReplace(_ctx.taxiLanguage[index].paxLang.p2c32, { '<voucher_code>': dataDetail?.voucher_code })
                                }, null, 8, _hoisted_67))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]))
  }), 128))
}